import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import I18n from 'I18n';
import EPSpotlight from 'editor-components/search/EPSpotlight';
// @ts-ignore not yet migrated
import { useNavigationGroups } from 'page-editor-ui/hooks/useNavigationGroups';
import { useTracker } from 'ContentEditorUI/utils/UsageTracker';
// @ts-ignore Not migrated yet
import { closeModal } from 'ContentEditorUI/redux/actions/appActions';
import { SIDEBAR_PANELS } from 'ContentEditorUI/lib/sidebar/constants';
// @ts-ignore Not migrated yet
import { getCanMABExperiment } from 'page-editor-ui/redux/selectors/mabExperimentSelectors';
import { setActivePatagoniaPanel, openPatagoniaSidebar
// @ts-ignore Not migrated yet
} from 'ContentEditorUI/redux/actions/panelActions';
// @ts-ignore Not migrated yet
import { updateSelectedCategory } from 'ContentEditorUI/redux/actions/sidebarActions';
// @ts-ignore Not migrated yet
import { getPatagoniaAddSidebarCategories } from 'ContentEditorUI/redux/selectors/sidebarCategorySelectors';
import { PATAGONIA_ADD_PANEL_CATEGORIES } from 'ContentEditorUI/constants/Sidebar';
import { AddIcon } from 'foundations-assets/icons/components/AddIcon';
import { EllipsesIcon } from 'foundations-assets/icons/components/EllipsesIcon';
import { FileIcon } from 'foundations-assets/icons/components/FileIcon';
import { GaugeIcon } from 'foundations-assets/icons/components/GaugeIcon';
import { SiteTreeIcon } from 'foundations-assets/icons/components/SiteTreeIcon';
import { TestIcon } from 'foundations-assets/icons/components/TestIcon';
import { jsx as _jsx } from "react/jsx-runtime";
const getSuggestionFromNavItem = (id, group, item) => {
  const category = group.id === 'help' ? I18n.text('spotlight.category.help') : I18n.text('spotlight.category.suggestedActions');
  // Always show if it's the general settings item or if its under the help group
  const hiddenUntilSearch = group.id !== 'help' && !(group.id === 'settings' && item.id === 'general');
  const onRun = () => {
    if (item.onClick) {
      item.onClick();
    } else if (item.href) {
      window.location.href = item.href;
    }
  };
  return {
    category,
    hiddenUntilSearch,
    id,
    icon: item.icon || EllipsesIcon,
    label: item.fullText || '',
    onRun
  };
};
const getSuggestionsFromNavGroupNestedChildren = (group, child) => {
  return child.nestedChildren ? child.nestedChildren.reduce((suggestions, nestedChild) => {
    if (!nestedChild.id || !nestedChild.fullText || nestedChild.hideLink || nestedChild.disableLink) {
      return suggestions;
    }
    if (nestedChild.onClick || nestedChild.href) {
      const id = `${group.id}-${child.id}-${nestedChild.id}`;
      suggestions.push(getSuggestionFromNavItem(id, group, nestedChild));
    }
    return suggestions;
  }, []) : [];
};
const getSuggestionsFromNavGroupChildren = group => {
  return group.children.reduce((suggestions, child) => {
    if (!child.id || child.hideLink || child.disableLink) {
      return suggestions;
    }
    if (child.onClick || child.href) {
      const id = `${group.id}-${child.id}`;
      suggestions.push(getSuggestionFromNavItem(id, group, child));
    }
    const nestedSuggestions = getSuggestionsFromNavGroupNestedChildren(group, child);
    suggestions.push(...nestedSuggestions);
    return suggestions;
  }, []);
};
const useNavigationSuggestions = () => {
  const navigationGroups = useNavigationGroups();
  const suggestionGroups = useMemo(() => navigationGroups.reduce((navigationSuggestionGroups, group) => {
    if (!group.id) {
      return navigationSuggestionGroups;
    }
    const suggestions = getSuggestionsFromNavGroupChildren(group);
    if (group.id === 'help') {
      navigationSuggestionGroups.helpSuggestions.push(...suggestions);
    } else {
      navigationSuggestionGroups.navigationSuggestions.push(...suggestions);
    }
    return navigationSuggestionGroups;
  }, {
    helpSuggestions: [],
    navigationSuggestions: []
  }), [navigationGroups]);
  return suggestionGroups;
};
const useAddModuleSuggestions = () => {
  const dispatch = useDispatch();
  const patagoniaAddSidebarCategories = useSelector(getPatagoniaAddSidebarCategories);
  const addModuleSuggestions = useMemo(() => {
    return patagoniaAddSidebarCategories.map(category => {
      let label = '';
      if (category === PATAGONIA_ADD_PANEL_CATEGORIES.MODULES) {
        label = I18n.text('spotlight.label.addModule');
      } else if (category === PATAGONIA_ADD_PANEL_CATEGORIES.SECTIONS) {
        label = I18n.text('spotlight.label.addSection');
      } else if (category === PATAGONIA_ADD_PANEL_CATEGORIES.LAYOUTS) {
        label = I18n.text('spotlight.label.addLayout');
      }
      return {
        category: I18n.text('spotlight.category.suggestedActions'),
        icon: AddIcon,
        id: `sidebar-${SIDEBAR_PANELS.addWidget}-${category}`,
        label,
        onRun: () => {
          dispatch(openPatagoniaSidebar());
          dispatch(setActivePatagoniaPanel(SIDEBAR_PANELS.addWidget));
          dispatch(updateSelectedCategory(category));
        }
      };
    });
  }, [dispatch, patagoniaAddSidebarCategories]);
  return addModuleSuggestions;
};
const useSidebarSuggestions = () => {
  const dispatch = useDispatch();
  const canMABExperiment = useSelector(getCanMABExperiment);
  const sidebarSuggestions = useMemo(() => [{
    category: I18n.text('spotlight.category.suggestedActions'),
    icon: SiteTreeIcon,
    id: `sidebar-${SIDEBAR_PANELS.pageContents}`,
    label: I18n.text('patagonia.sidebar.tooltipLabel.pageContents'),
    onRun: () => {
      dispatch(openPatagoniaSidebar());
      dispatch(setActivePatagoniaPanel(SIDEBAR_PANELS.pageContents));
    }
  }, {
    category: I18n.text('spotlight.category.suggestedActions'),
    icon: GaugeIcon,
    id: `sidebar-${SIDEBAR_PANELS.optimizer}`,
    label: I18n.text('patagonia.sidebar.tooltipLabel.optimizer'),
    onRun: () => {
      dispatch(openPatagoniaSidebar());
      dispatch(setActivePatagoniaPanel(SIDEBAR_PANELS.optimizer));
    }
  }, ...(canMABExperiment ? [{
    category: I18n.text('spotlight.category.suggestedActions'),
    icon: TestIcon,
    id: `sidebar-${SIDEBAR_PANELS.tools}`,
    label: I18n.text('patagonia.sidebar.tooltipLabel.test'),
    onRun: () => {
      dispatch(openPatagoniaSidebar());
      dispatch(setActivePatagoniaPanel(SIDEBAR_PANELS.tools));
    },
    disabled: !canMABExperiment
  }] : []), {
    category: I18n.text('spotlight.category.suggestedActions'),
    icon: FileIcon,
    id: `sidebar-${SIDEBAR_PANELS.pageManagement}`,
    label: I18n.text('patagonia.sidebar.tooltipLabel.pageManagement'),
    onRun: () => {
      dispatch(openPatagoniaSidebar());
      dispatch(setActivePatagoniaPanel(SIDEBAR_PANELS.pageManagement));
    }
  }], [canMABExperiment, dispatch]);
  return sidebarSuggestions;
};
const Spotlight = () => {
  const dispatch = useDispatch();
  const tracker = useTracker();
  const onClose = useCallback(() => {
    return dispatch(closeModal());
  }, [dispatch]);
  const addModuleSuggestions = useAddModuleSuggestions();
  const sidebarSuggestions = useSidebarSuggestions();
  const {
    helpSuggestions,
    navigationSuggestions
  } = useNavigationSuggestions();
  const suggestions = useMemo(() => {
    return [...addModuleSuggestions, ...sidebarSuggestions, ...navigationSuggestions, ...helpSuggestions];
  }, [addModuleSuggestions, sidebarSuggestions, helpSuggestions, navigationSuggestions]);
  return !!tracker && /*#__PURE__*/_jsx(EPSpotlight, {
    maxSuggestions: 8,
    onClose: onClose,
    placeholder: I18n.text('spotlight.search.placeholder'),
    suggestions: suggestions,
    usageTracker: tracker
  });
};
export default Spotlight;